import React from 'react';
interface LogoProps {
  className?: string;
  variant?: 'shield' | 'inline';
  /** Render a white version for dark backgrounds (uses CSS filter to invert) */
  onDark?: boolean;
}
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/fNaz6RqAKLSwKjFRY9S5m4/mobile-logo-dark.6c852519_1.png';
/**
 * East West University wordmark (user-provided asset).
 */
export function Logo({
  className = '',
  variant = 'shield',
  onDark = false
}: LogoProps) {
  const height = variant === 'inline' ? 'h-9' : 'h-14';
  return <img src={LOGO_SRC} alt="East West University" className={`${height} w-auto object-contain ${onDark ? 'brightness-0 invert' : ''} ${className}`} data-id="element-170" />;
}